import serverRequestUtil from '../utils/ServerRequestUtil';

export default new class {
    constructor() {}

    payment(input) {
        let params = Object.assign({}, input);

        // 数量は数値として扱う
        if (params.amount !== undefined && params.amount !== null) {
            params.amount = parseInt(Math.round(params.amount));
        }

        // サーバーサイドで計算できるものについては不正対策も兼ねてリクエストから削除する
        if (params.price !== undefined && params.price !== null) {
            delete params.price;
        }
        if (params.tax !== undefined && params.tax !== null) {
            delete params.tax;
        }
        if (params.total !== undefined && params.total !== null) {
            delete params.total;
        }

        return serverRequestUtil.post('api/app/order/payment', { ...params });
    }

    getHecPriceByUSD(usd) {
        return serverRequestUtil.post('api/app/order/price', { usd });
    }
}